import { color, duration, size, spacing, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import Box from "../../Box";
import { SelectedText } from "./SelectedText";
const animationDuration = duration.animation.fast;
export const ContentContainer = styled(Box) `
  background-color: ${color.background.input.default};
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;
  transition:
    background-color ${animationDuration}ms ease,
    box-shadow ${animationDuration}ms ease;
  outline: none;
  border: solid ${size.border.base.hairline} ${color.border.input.default};

  // Set the inset manually because we have to subtract the border size
  padding: calc(${spacing.insetSquish.m.y} - ${size.border.base.hairline})
    calc(${spacing.insetSquish.m.x} - ${size.border.base.hairline});

  // Set the height to 40px
  height: calc(
    ${size.lineHeight.text.default} + ${spacing.insetSquish.m.y} * 2
  );

  &.active {
    border-color: ${color.border.input.focused};
    background-color: ${color.background.input.focused};
  }

  &:not(.disabled) {
    &:hover:not(.active),
    &.hover {
      background-color: ${color.background.input.hovered};
    }
  }

  &.placeholder > ${SelectedText} {
    color: ${color.font.input.placeholder};
  }

  &.focus,
  &:focus {
    background-color: ${color.background.input.focused};
    border-color: ${color.border.input.focused};
  }

  &.hasError:not(.focus):not(:focus) {
    border-color: ${color.border.input.error};
    background-color: ${color.background.input.error};
  }

  & .icon {
    color: ${color.font.link.default};
  }

  &.disabled {
    background-color: ${color.background.input.disabled};
    cursor: not-allowed;

    & > ${SelectedText} {
      color: ${color.font.input.disabled};
    }

    & .icon {
      color: ${color.font.input.disabled};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudENvbnRhaW5lci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1NlbGVjdC9zdHlsZWQvQ29udGVudENvbnRhaW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQ0wsS0FBSyxFQUNMLFFBQVEsRUFDUixJQUFJLEVBQ0osT0FBTyxHQUNSLE1BQU0sZ0RBQWdELENBQUM7QUFDeEQsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxHQUFHLE1BQU0sV0FBVyxDQUFDO0FBQzVCLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUU5QyxNQUFNLGlCQUFpQixHQUFHLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDO0FBRWxELE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQTtzQkFDckIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsT0FBTzs7Ozs7dUJBSzdCLGlCQUFpQjtpQkFDdkIsaUJBQWlCOztrQkFFaEIsSUFBSSxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsUUFBUSxJQUFJLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLE9BQU87OztrQkFHdkQsT0FBTyxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFFBQVE7V0FDN0QsT0FBTyxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLElBQUksQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFFBQVE7Ozs7TUFJM0QsSUFBSSxDQUFDLFVBQVUsQ0FBQyxJQUFJLENBQUMsT0FBTyxNQUFNLE9BQU8sQ0FBQyxXQUFXLENBQUMsQ0FBQyxDQUFDLENBQUM7Ozs7b0JBSTNDLEtBQUssQ0FBQyxNQUFNLENBQUMsS0FBSyxDQUFDLE9BQU87d0JBQ3RCLEtBQUssQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLE9BQU87Ozs7OzswQkFNNUIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsT0FBTzs7OztvQkFJcEMsWUFBWTthQUNuQixLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxXQUFXOzs7Ozt3QkFLakIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsT0FBTztvQkFDbEMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsT0FBTzs7OztvQkFJMUIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsS0FBSzt3QkFDcEIsS0FBSyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsS0FBSzs7OzthQUl2QyxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPOzs7O3dCQUlaLEtBQUssQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLFFBQVE7OztVQUc3QyxZQUFZO2VBQ1AsS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsUUFBUTs7OztlQUl6QixLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxRQUFROzs7Q0FHdkMsQ0FBQyJ9